import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { invoiceService } from '../services/api';
import './Dashboard.css';

function Dashboard({ user }) {
  const [stats, setStats] = useState({
    total: 0,
    draft: 0,
    pending: 0,
    approved: 0,
    rejected: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await invoiceService.listInvoices();
      const invoices = response.invoices;
      
      const newStats = {
        total: invoices.length,
        draft: invoices.filter(inv => inv.status === 'draft').length,
        pending: invoices.filter(inv => inv.status === 'pending_approval').length,
        approved: invoices.filter(inv => inv.status === 'approved').length,
        rejected: invoices.filter(inv => inv.status === 'rejected').length
      };
      
      setStats(newStats);
    } catch (error) {
      console.error('Error loading stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="container loading">Cargando...</div>;
  }

  return (
    <div className="container">
      <div className="dashboard-header">
        <h1>Dashboard</h1>
        <p>Bienvenido, {user.name}</p>
      </div>
      
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total de Facturas</h3>
          <p className="stat-number">{stats.total}</p>
        </div>
        
        <div className="stat-card">
          <h3>Borradores</h3>
          <p className="stat-number">{stats.draft}</p>
        </div>
        
        <div className="stat-card">
          <h3>Pendientes de Aprobación</h3>
          <p className="stat-number">{stats.pending}</p>
        </div>
        
        <div className="stat-card">
          <h3>Aprobadas</h3>
          <p className="stat-number">{stats.approved}</p>
        </div>
        
        <div className="stat-card">
          <h3>Rechazadas</h3>
          <p className="stat-number">{stats.rejected}</p>
        </div>
      </div>
      
      <div className="quick-actions">
        <h2>Acciones Rápidas</h2>
        <div className="actions-grid">
          {user.canCreateInvoices && (
            <Link to="/invoices/new" className="action-card">
              <h3>Nueva Factura</h3>
              <p>Cargar una nueva factura para validación</p>
            </Link>
          )}
          
          <Link to="/invoices" className="action-card">
            <h3>Ver Facturas</h3>
            <p>Revisar todas las facturas</p>
          </Link>
          
          {(user.role === 'supervisor' || user.role === 'administrador') && (
            <Link to="/approval" className="action-card">
              <h3>Cola de Aprobación</h3>
              <p>Revisar facturas pendientes de aprobación</p>
            </Link>
          )}

          {user.canManageMasterData && (
            <Link to="/masterdata-management" className="action-card">
              <h3>Master Data</h3>
              <p>Gestionar tablas maestras de sociedades, proveedores e impuestos</p>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
